module.exports = __webpack_public_path__ + "static/media/MINISERIF-BOLD.907d2d4c.OTF";